import { render, staticRenderFns } from "./performanceFinsh.vue?vue&type=template&id=27b87a40"
import script from "./performanceFinsh.vue?vue&type=script&lang=js"
export * from "./performanceFinsh.vue?vue&type=script&lang=js"
import style0 from "./performanceFinsh.vue?vue&type=style&index=0&id=27b87a40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports